// extracted by mini-css-extract-plugin
export var closeButton = "_h4-2";
export var closeButtonIcon = "_h4-3";
export var lightboxContent = "_h4-1";
export var lightboxOverlay = "_h4-0";